export const subjectNS = {
    CHEMISTRY: 'chemistry',
    PHYSICS: 'physics',
    MATHS: 'maths',
    BOTANY: 'botany',
    ZOOLOGY: 'zoology',
    COMPUTER_SCIENCE: 'computer'
}

export const subjectColors = {
    chemistry:
        ' radial-gradient(63.33% 63.33% at 18% 24.67%, #FDCBA5 0%, #FD8A41 100%)',
    physics:
        'radial-gradient(63.33% 63.33% at 18% 24.67%, #FDCBA5 0%, #FD8A41 100%)',

    maths: 'radial-gradient(78% 78% at 0% 22%, #93D1FC 5.73%, #29A0F3 100%)',
    botany: 'radial-gradient(75.33% 75.33% at 14.67% 24.67%, #E38EE1 0%, #FE44DD 100%)',
    zoology:
        ' radial-gradient(63.33% 63.33% at 11.33% 24.67%, #A580E4 0%, #7950FE 100%)',
    computer:
        ' radial-gradient(63.33% 63.33% at 14% 18.67%, #88FB93 0%, #2DDD60 100%)'
}

export const subjectNames = {
    chemistry: 'Chemistry',
    physics: 'Physics',
    maths: 'Maths',
    botany: 'Botany',
    zoology: 'Zoology',
    computer: 'Computer'
}

const plusOneChapters = {
    chemistry: [
        {
            chapterNo: 1,
            chapterName: 'Some Basic Concepts of Chemistry'
        },
        {
            chapterNo: 2,
            chapterName: 'Structure of Atom'
        },
        {
            chapterNo: 3,
            chapterName:
                'Classification of Elements and Periodicity in Properties'
        },
        {
            chapterNo: 4,
            chapterName: 'Chemical Bonding and Molecular Structure'
        },
        {
            chapterNo: 5,
            chapterName: 'States of Matter'
        },
        {
            chapterNo: 6,
            chapterName: 'Thermodynamics'
        },
        {
            chapterNo: 7,
            chapterName: 'Equilibrium'
        },
        {
            chapterNo: 8,
            chapterName: 'Redox Reactions'
        },
        {
            chapterNo: 9,
            chapterName: 'Hydrogen'
        },
        {
            chapterNo: 10,
            chapterName: 'The s-Block Elements'
        },
        {
            chapterNo: 11,
            chapterName: 'The p-Block Elements'
        },
        {
            chapterNo: 12,
            chapterName:
                'Organic Chemistry Some Basic Principles and Techniques'
        },
        {
            chapterNo: 13,
            chapterName: 'Hydrocarbons'
        },
        {
            chapterNo: 14,
            chapterName: 'Environmental Chemistry'
        },
        {
            chapterNo: 15,
            chapterName: 'Other'
        }
    ],
    physics: [
        {
            chapterNo: 1,
            chapterName: 'Physical World'
        },
        {
            chapterNo: 2,
            chapterName: 'Units and Measurement'
        },
        {
            chapterNo: 3,
            chapterName: 'Motion in a Straight Line'
        },
        {
            chapterNo: 4,
            chapterName: 'Motion in a Plane'
        },
        {
            chapterNo: 5,
            chapterName: 'Laws of Motion'
        },
        {
            chapterNo: 6,
            chapterName: 'Work, Energy and Power'
        },
        {
            chapterNo: 7,
            chapterName: 'Systems of Particles and Rotational Motion'
        },
        {
            chapterNo: 8,
            chapterName: 'Gravitation'
        },
        {
            chapterNo: 9,
            chapterName: 'Mechanical Properties of Solids'
        },
        {
            chapterNo: 10,
            chapterName: 'Mechanical Properties of Fluids'
        },
        {
            chapterNo: 11,
            chapterName: 'Thermal Properties of Matter'
        },
        {
            chapterNo: 12,
            chapterName: 'Thermodynamics'
        },
        {
            chapterNo: 13,
            chapterName: 'Kinetic Theory'
        },
        {
            chapterNo: 14,
            chapterName: 'Oscillations'
        },
        {
            chapterNo: 15,
            chapterName: 'Waves'
        },
        {
            chapterNo: 16,
            chapterName: 'Other'
        }
    ],
    maths: [
        {
            chapterNo: 1,
            chapterName: 'Sets'
        },
        {
            chapterNo: 2,
            chapterName: 'Relations and Functions'
        },
        {
            chapterNo: 3,
            chapterName: 'Trigonometric Functions'
        },
        {
            chapterNo: 4,
            chapterName: 'Principle of Mathematical Induction'
        },
        {
            chapterNo: 5,
            chapterName: 'Complex Numbers and Quadratic Equations'
        },
        {
            chapterNo: 6,
            chapterName: 'Linear Inequalities'
        },
        {
            chapterNo: 7,
            chapterName: 'Permutation and Combinations'
        },
        {
            chapterNo: 8,
            chapterName: 'Binomial Theorem'
        },
        {
            chapterNo: 9,
            chapterName: 'Sequences and Series'
        },
        {
            chapterNo: 10,
            chapterName: 'Straight Lines'
        },
        {
            chapterNo: 11,
            chapterName: 'Conic Sections'
        },
        {
            chapterNo: 12,
            chapterName: 'Introduction to Three Dimensional Geometry'
        },
        {
            chapterNo: 13,
            chapterName: 'Limits and Derivatives'
        },
        {
            chapterNo: 14,
            chapterName: 'Mathematical Reasoning'
        },
        {
            chapterNo: 15,
            chapterName: 'Statistics'
        },
        {
            chapterNo: 16,
            chapterName: 'Probability'
        },
        {
            chapterNo: 17,
            chapterName: 'Other'
        }
    ],
    botany: [
        {
            chapterNo: 1,
            chapterName: 'Biological Classification'
        },
        {
            chapterNo: 2,
            chapterName: 'Plant Kingdom'
        },
        {
            chapterNo: 3,
            chapterName: 'Morphology of Flowering Plants'
        },
        {
            chapterNo: 4,
            chapterName: 'Anatomy of Flowering Plants'
        },
        {
            chapterNo: 5,
            chapterName: 'Cell The Unit of Life'
        },
        {
            chapterNo: 6,
            chapterName: 'Cell Cycle and Cell Division'
        },
        {
            chapterNo: 7,
            chapterName: 'Transport in Plants'
        },
        {
            chapterNo: 8,
            chapterName: 'Mineral Nutrition'
        },
        {
            chapterNo: 9,
            chapterName: 'Photosynthesis in Higher Plants'
        },
        {
            chapterNo: 10,
            chapterName: 'Respiration in Plants'
        },
        {
            chapterNo: 11,
            chapterName: 'Plant Growth and Development'
        },
        {
            chapterNo: 12,
            chapterName: 'Other'
        }
    ],
    zoology: [
        {
            chapterNo: 1,
            chapterName: 'The Living World'
        },
        {
            chapterNo: 2,
            chapterName: 'Animal Kingdom'
        },
        {
            chapterNo: 3,
            chapterName: 'Structural Organisation in Animals'
        },
        {
            chapterNo: 4,
            chapterName: 'Biomolecules'
        },
        {
            chapterNo: 5,
            chapterName: 'Digestion and Absorption'
        },
        {
            chapterNo: 6,
            chapterName: 'Breathing and Exchange of Gases'
        },
        {
            chapterNo: 7,
            chapterName: 'Body Fluids and Circulation'
        },
        {
            chapterNo: 8,
            chapterName: 'Excretory Products and their Elimination'
        },
        {
            chapterNo: 9,
            chapterName: 'Locomotion and Movement'
        },
        {
            chapterNo: 10,
            chapterName: 'Neural Control and Coordination'
        },
        {
            chapterNo: 11,
            chapterName: 'Chemical Coordination and integration'
        },
        {
            chapterNo: 12,
            chapterName: 'Other'
        }
    ],
    computer: [
        {
            chapterNo: 1,
            chapterName: 'Discipline Of Computing'
        },
        {
            chapterNo: 2,
            chapterName: 'Data Representation And Boolean Algebra'
        },
        {
            chapterNo: 3,
            chapterName: 'Components of Computer System'
        },
        {
            chapterNo: 4,
            chapterName: 'Principle of Programming And Problem Solving'
        },
        {
            chapterNo: 5,
            chapterName: 'Introduction to C++'
        },
        {
            chapterNo: 6,
            chapterName: 'Data Types And Operators'
        },
        {
            chapterNo: 7,
            chapterName: 'Control Statements'
        },
        {
            chapterNo: 8,
            chapterName: 'Array'
        },
        {
            chapterNo: 9,
            chapterName: 'String Handling And  I/O Functions'
        },
        {
            chapterNo: 10,
            chapterName: 'Functions'
        },
        {
            chapterNo: 11,
            chapterName: 'Computer Networks'
        },
        {
            chapterNo: 12,
            chapterName: 'Internet And Mobile Computing'
        }
    ]
}

const plusTwoChapters = {
    chemistry: [
        {
            chapterNo: 1,
            chapterName: 'The Solid State'
        },
        {
            chapterNo: 2,
            chapterName: 'Solutions'
        },
        {
            chapterNo: 3,
            chapterName: 'Electrochemistry'
        },
        {
            chapterNo: 4,
            chapterName: 'Chemical Kinetics'
        },
        {
            chapterNo: 5,
            chapterName: 'Surface Chemistry'
        },
        {
            chapterNo: 6,
            chapterName:
                'General Principle and Processes of Isolation of Elements'
        },
        {
            chapterNo: 7,
            chapterName: 'The p Block Elements'
        },
        {
            chapterNo: 8,
            chapterName: 'The d and  Block Elements'
        },
        {
            chapterNo: 9,
            chapterName: 'Coordination Compounds'
        },
        {
            chapterNo: 10,
            chapterName: 'Haloalkanes and Haloarenes'
        },
        {
            chapterNo: 11,
            chapterName: 'Alcohols, Phenols and Ethers'
        },
        {
            chapterNo: 12,
            chapterName: 'Aldehydes, Ketones and Carboxylic Acids'
        },
        {
            chapterNo: 13,
            chapterName: 'Amines'
        },
        {
            chapterNo: 14,
            chapterName: 'Biomolecules'
        },
        {
            chapterNo: 15,
            chapterName: 'Polymers'
        },
        {
            chapterNo: 16,
            chapterName: 'Chemistry in Everyday Life'
        }
    ],
    physics: [
        {
            chapterNo: 1,
            chapterName: 'Electric Charges and Fields'
        },
        {
            chapterNo: 2,
            chapterName: 'Electric Potential and Capacitance'
        },
        {
            chapterNo: 3,
            chapterName: 'Current Electricity'
        },
        {
            chapterNo: 4,
            chapterName: 'Moving Charges and Magnetism'
        },
        {
            chapterNo: 5,
            chapterName: 'Magnetism and Matter'
        },
        {
            chapterNo: 6,
            chapterName: 'Electromagnetic Induction'
        },
        {
            chapterNo: 7,
            chapterName: 'Alternating Current'
        },
        {
            chapterNo: 8,
            chapterName: 'Electromagnetic Waves'
        },
        {
            chapterNo: 9,
            chapterName: 'Ray Optics and Optical Instruments'
        },
        {
            chapterNo: 10,
            chapterName: 'Wave Optic'
        },
        {
            chapterNo: 11,
            chapterName: 'Dual Nature of Radiation and Matter'
        },
        {
            chapterNo: 12,
            chapterName: 'Atoms'
        },
        {
            chapterNo: 13,
            chapterName: 'Nuclei'
        },
        {
            chapterNo: 14,
            chapterName:
                'Semiconductor Electronics : Materials, Devices and Simple Circuits'
        },
        {
            chapterNo: 15,
            chapterName: 'Communication Systems'
        }
    ],
    maths: [
        {
            chapterNo: 1,
            chapterName: 'Relations and Functions'
        },
        {
            chapterNo: 2,
            chapterName: 'Inverse Trigonometric Functions'
        },
        {
            chapterNo: 3,
            chapterName: 'Matrices'
        },
        {
            chapterNo: 4,
            chapterName: 'Determinants'
        },
        {
            chapterNo: 5,
            chapterName: 'Continuity and Differentiability'
        },
        {
            chapterNo: 6,
            chapterName: 'Application of Derivatives'
        },
        {
            chapterNo: 7,
            chapterName: 'Integrals'
        },
        {
            chapterNo: 8,
            chapterName: 'Application of Integrals'
        },
        {
            chapterNo: 9,
            chapterName: 'Differential Equations'
        },
        {
            chapterNo: 10,
            chapterName: 'Vector Algebra'
        },
        {
            chapterNo: 11,
            chapterName: 'Three Dimensional Geometry'
        },
        {
            chapterNo: 12,
            chapterName: 'Linear Programming'
        },
        {
            chapterNo: 13,
            chapterName: 'Probability'
        }
    ],
    botany: [
        {
            chapterNo: 1,
            chapterName: 'Reproduction in Organisms'
        },
        {
            chapterNo: 2,
            chapterName: 'Sexual Reproduction in Flowering Plants'
        },
        {
            chapterNo: 3,
            chapterName: 'Strategies for Enhancement in Food Production'
        },
        {
            chapterNo: 4,
            chapterName: 'Biotechnology: Principles and Processes'
        },
        {
            chapterNo: 5,
            chapterName: 'Biotechnology and its Applications'
        },
        {
            chapterNo: 6,
            chapterName: 'Organisms and Populations'
        },
        {
            chapterNo: 7,
            chapterName: 'Ecosystem'
        },
        {
            chapterNo: 8,
            chapterName: 'Environmental Issues'
        }
    ],
    zoology: [
        {
            chapterNo: 1,
            chapterName: 'Human Reproduction'
        },
        {
            chapterNo: 2,
            chapterName: 'Reproductive Health'
        },
        {
            chapterNo: 3,
            chapterName: 'Principles of Inheritance and Variation'
        },
        {
            chapterNo: 4,
            chapterName: 'Molecular Basis of Inheritance'
        },
        {
            chapterNo: 5,
            chapterName: 'Evolution'
        },
        {
            chapterNo: 6,
            chapterName: 'Human Health and Disease'
        },
        {
            chapterNo: 7,
            chapterName: 'Microbes in Human Welfare'
        },
        {
            chapterNo: 8,
            chapterName: 'Biodiversity and Conservation'
        }
    ],
    computer: [
        {
            chapterNo: 1,
            chapterName: 'Structure And Pointer'
        },
        {
            chapterNo: 2,
            chapterName: 'Oops Concepts'
        },
        {
            chapterNo: 3,
            chapterName: 'Data Structures'
        },
        {
            chapterNo: 4,
            chapterName: 'Web Technology'
        },
        {
            chapterNo: 5,
            chapterName: 'Web Designing Using HTML'
        },
        {
            chapterNo: 6,
            chapterName: 'Client Side Scripting Using JavaScript'
        },
        {
            chapterNo: 7,
            chapterName: 'Web Hosting'
        },
        {
            chapterNo: 8,
            chapterName: 'Database Management System'
        },
        {
            chapterNo: 9,
            chapterName: 'SQL Structured Query Language'
        },
        {
            chapterNo: 10,
            chapterName: 'Server Side Scripting Using PHP'
        },
        {
            chapterNo: 11,
            chapterName: 'Advances In Computing'
        },
        {
            chapterNo: 12,
            chapterName: 'ICT And Society'
        }
    ]
}

export const chapters = {
    plusOneChapters: plusOneChapters,
    plusTwoChapters: plusTwoChapters
}
